import React, { useEffect, useState } from 'react'
import { Button, CircularProgress, TextField, ButtonGroup } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { useFilters } from '../_redux/slice'
import { fetchStructure, updateTreeStructData } from '../_redux/thunk'
import { Autocomplete, ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import { ButtonToolbar } from "react-bootstrap";
import { recursiveGetMachinesByKey, recursiveGetLinesByKey, recursiveGetIds, recursiveGetPilarsByKey } from '../../../helpers/three';
import { Tooltip, withStyles } from '@material-ui/core';
import _ from 'lodash'
import { useStore } from '../../../../app/provider/zustandProvider'

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 15,
        whiteSpace: 'pre-line'
    },
}))(Tooltip);

const ButtonNormal = withStyles({
    root: {
        "&.Mui-disabled": {
            pointerEvents: "auto"
        }
    }
})(Button);

const ButtonWithTooltip = ({ tooltiptext, disabled, onClick, ...other }) => {
    const adjustedButtonProps = {
        disabled: disabled,
        component: disabled ? "div" : undefined,
        onClick: disabled ? undefined : onClick
    };
    return (
        <LightTooltip title={tooltiptext}>
            <ButtonNormal {...other} {...adjustedButtonProps} />
        </LightTooltip>
    );
};

const ButtonDemo = props => {    
    return (
        <LightTooltip title={props.tooltiptext}>
            <span>
                <Button {...props} className={props.showselect ? "btn btn-info" : "btn btn-primary"}>
                    {props.title}
                </Button>
            </span>
        </LightTooltip>
    );
};

/**
 * @typedef {object} Structure
 * @property {Number} id
 * @property {String} code
 * @property {{name: String}} father
 * @property {String} name
 */
/**
 * A cada 5 minutos o componente tem permisão de carregar as struct
 * @param {import('@material-ui/lab').AutocompleteProps<Structure> & {
 *  lifecycle?: Number,
 * }} param0 
 * @returns 
 */
const SetorLinhaMaquina = ({ lifecycle = 0, ...props }) => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const [startComponent, setStarted] = useState(false);
    const { struct } = useFilters()
    const { chosenToggleState, OnChangeToggleState, chosenSectorState, OnChangeSectorState, chosenLineState, chosenPilarState, OnChangeLineState,
            chosenMachineState, OnChangeMachineState    } = useStore();
    const sectors = struct.entities.filter(x => (x.structureType == "Setor" || x.structureType == "TLF" ||
        x.structureType == "LL" || x.structureType == "subLL" || x.structureType == "Grupo"));
    const lines = struct.entities.filter(x => (x.structureType == "Linha" )); //|| x.structureType == "Pilar"
    const pilars = struct.entities.filter(x => (x.structureType == "Pilar"));
    const machines = struct.entities.filter(x => (x.structureType == "Máquina" || x.structureType == "Ativo"));
    
    const [chosenToggle, setChosenToggle] = useState(chosenToggleState);
    const [placeholderChosen, setPlaceholderChosen] = useState('Setores');

    const [itemList, setItemList] = useState([]);
    const [chosenSector, setChosenSector] = useState(chosenSectorState);
    const [chosenLine, setChosenLine] = useState(chosenLineState);
    const [chosenPilar, setChosenPilar] = useState(chosenPilarState);
    const [chosenMachine, setChosenMachine] = useState(chosenMachineState);
    const [currentChosen, setCurrentChosen] = useState({ name: '' });

    useEffect(() => {
        if (itemList.length == 0 && sectors.length > 0 && !startComponent) {
            var chosen = null;
            switch (chosenToggle) {
                case 'sectors':
                default:
                    setItemList(sectors);
                    chosen = chosenSector;
                    setCurrentChosen(chosenSector);
                    break;                
                case 'lines':
                    setLinesList();
                    chosen = chosenLine;                    
                    break;
                case 'pilars':
                    setPilarsList()
                    chosen = chosenPilar;
                    break
                case 'machines':
                    setMachinesList();
                    chosen = chosenMachine;
                    break;
            }
            props.onChange(null, chosen);
            setStarted(true);
        }
    }, [sectors]);

    const handleChangeOption = (event, param) => {
        var value;
        if (param == null)
            value = { name: '' };
        else
            value = param;
        setCurrentChosen(value);
        //setChosenToggle(value[value.length - 1])      
        switch (chosenToggle) {
            case 'sectors':
            default:
                setChosenSector(value);
                OnChangeSectorState(value);
                setChosenLine({ name: '' });
                setChosenPilar({ name: '' });
                setChosenMachine({ name: '' });
                break;
            case 'lines':
                setChosenLine(value);
                OnChangeLineState(value);
                setChosenPilar({ name: '' });
                setChosenMachine({ name: '' });
                break;
            case 'pilars':
                setChosenPilar(value);
                setChosenMachine({ name: '' });
                break
            case 'machines':
                setChosenMachine(value);
                setChosenPilar({ name: '' });
                OnChangeMachineState(value);
                break;
        }
        props.onChange(event, value);
    }


    const click = (value) => {
        //console.log(value)
        setChosenToggle(value)
        OnChangeToggleState(value);
        switch (value) {
            case 'sectors':
            default:
                setItemList(sectors);
                setCurrentChosen(chosenSector);
                props.onChange(null, chosenSector);
                setPlaceholderChosen('Setores');
                break;
            case 'lines':
                setLinesList();
                props.onChange(null, chosenLine);
                setPlaceholderChosen('Linhas');
                break;
            case 'pilars':
                setPilarsList()
                props.onChange(null, chosenPilar);
                setPlaceholderChosen('Pilares');
                break
            case 'machines':
                setMachinesList();
                props.onChange(null, chosenMachine);
                setPlaceholderChosen('Maquinas');
                break;
           
        }
    }

    const setLinesList = () => {
        if (chosenSector && chosenSector?.name != '') {
            var vectorChosen = []
            vectorChosen.push(chosenSector);
            const selectedNodes = recursiveGetLinesByKey(chosenSector.id, vectorChosen, []);
            setItemList(selectedNodes);
            //console.log('selectedNodes', selectedNodes);
        }
        else {
            setItemList(lines);
        }
        setCurrentChosen(chosenLine);
    }

    const setPilarsList = () => {
        if (chosenLine && chosenLine?.name != '') {
            var vectorChosen = []
            vectorChosen.push(chosenLine);
            const selectedNodes = recursiveGetPilarsByKey(chosenLine.id, vectorChosen, []);
            setItemList(selectedNodes);
        }
        else {
            setItemList(pilars);
        }
        setCurrentChosen(chosenPilar);
    }

    const setMachinesList = () => {
        if (chosenLine && chosenLine?.name != '') {
            var vectorChosen = []
            vectorChosen.push(chosenLine);
            const selectedNodes = recursiveGetMachinesByKey(chosenLine.id, vectorChosen, []);
            setItemList(selectedNodes);
            console.log('selectedNodes', selectedNodes);
        }
        else {
            if (chosenSector && chosenSector?.name != '') {
                var vectorChosen = []
                vectorChosen.push(chosenSector);
                const selectedNodes = recursiveGetMachinesByKey(chosenSector.id, vectorChosen, []);
                setItemList(selectedNodes);
                console.log('selectedNodes', selectedNodes);
            }
            else {
                setItemList(machines);
            }
        }
        setCurrentChosen(chosenMachine);
    }

    const loading = !!(open && (struct.entities.length === 0 || (lifecycle && struct.timeStamp + (lifecycle * 1000) <= _.now())))
    useEffect(() => {

        if (!loading) {
            return undefined;
        }

        dispatch(updateTreeStructData())

    }, [loading])

    return (
        <>
            <ButtonGroup
                value={chosenToggle}
                type="radio"
                name="options"
                // onChange={handleChangeOption}
                variant="contained"
                size="large"
                aria-label="contained primary button group"
            >
                <ButtonDemo style={{marginRight: '3px'}} showselect={chosenSector.name ? true : false} tooltiptext={(chosenSector.name ? 'Setor selecionado: ' + chosenSector.name : '') + "\n\nSerão filtrados todas as linhas/máquinas dentro do setor selecionado."} disabled={chosenToggle == 'sectors'} onClick={(e) => click('sectors')} value={'sectors'} title='SETORES'></ButtonDemo>
                <ButtonDemo style={{marginRight: '3px'}} showselect={chosenLine.name ? true : false} tooltiptext={(chosenLine.name ? 'Linha selecionada: ' + chosenLine.name : '') + '\n\nSerão filtradas todas as máquinas dentro da linha selecionada.'} disabled={chosenToggle == 'lines'} onClick={(e) => click('lines')} value={'lines'} title='LINHAS'></ButtonDemo>
                <ButtonDemo style={{marginRight: '3px'}} showselect={chosenPilar.name ? true : false} tooltiptext={(chosenPilar.name ? 'Linha selecionada: ' + chosenPilar.name : '') + '\n\nSerão filtradas todas as máquinas dentro do pilar selecionada.'} disabled={chosenToggle === 'pilars'} onClick={(e) => click('pilars')} value={'pilars'} title='Pilares'></ButtonDemo>
                <ButtonDemo showselect={chosenMachine.name ? true : false} tooltiptext={(chosenMachine.name ? 'Máquina selecionada: ' + chosenMachine.name : '')} disabled={chosenToggle == 'machines'} onClick={(e) => click('machines')} value={'machines'} title='MÁQUINAS'></ButtonDemo>
            </ButtonGroup>

            {/* <ButtonToolbar >
                <ToggleButtonGroup value={chosenToggle } type="radio" name="options" onChange={handleChangeOption}>
                    <ToggleButton className="btn btn-primary"  value={'sectors'}>Setores</ToggleButton>
                    <ToggleButton className="btn btn-primary" value={'lines'}>Linhas</ToggleButton>
                    <ToggleButton className="btn btn-primary" value={'machines'}>Máquinas</ToggleButton>
                    </ToggleButtonGroup>
            </ButtonToolbar> */}

            <Autocomplete
                className="w-100"
                getOptionSelected={(option, value) => option.name === value.name}
                getOptionLabel={(option) => option.name + (option.father ? (' (' + option.father + ')') : '')}
                {...props}
                onChange={handleChangeOption}
                value={currentChosen}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                options={itemList}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label=""
                        placeholder={placeholderChosen}
                        variant="standard"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
            />
        </>
    )
}

export default SetorLinhaMaquina